import React, { useState } from "react";
import Image from "../../../../components/elements/Image";
import { useQuery, useQueryClient, useMutation } from "@tanstack/react-query";
import {
  changeOrganization,
  organizationListFront,
} from "../../../../services/organizationService";
import { lngDetect } from "../../../../helpers/lngDetect";
import { useSelector } from "react-redux";
import { classNames } from "../../../../helpers/classNames";
import Button from "../../../../components/form/Button";
import { useDebounce } from "../../../../hooks/useDebounce";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { TiptapContent } from "../../../../components/elements/tiptap-editor/EditorComponent";
import { setOrganization } from "../../../../redux/slice/organizationSlice";
import { useDispatch } from "react-redux";
import OrganizationItem from "./OrganizationItem";
import { useTranslation } from "react-i18next";

const organization = [
  {
    section: "Organizer Profiles",
    description: `Every organizer has a dedicated profile showcasing their events in one place. A complete profile helps attract and retain followers. Learn more.`,
  },
];

export default function OrganizationOverview() {
  const { t } = useTranslation();
  const [drawerOpen, setDrawerOpen] = useState({ isOpen: false, data: null });
  const [selectedItems, setSelectedItems] = useState([]);
  const [keyword, setKeyword] = useState("");
  const search = useDebounce(keyword, 300);
  const queryClient = useQueryClient();
  const [deleteModal, setDeleteModal] = useState({
    isOpen: false,
    data: null,
  });
  const [filters, setFilters] = useState({
    limit: 10,
    page: 1,
    sortQuery: "-createdAt",
  });

  const { selectedOrganization, organizations } = useSelector(
    (state) => state?.organization
  );

  const { data: organizerData, isLoading } = useQuery({
    queryKey: ["organizer-front", filters, search],
    queryFn: async () => {
      const res = await organizationListFront({
        ...filters,
        ...(search && { keyword: search }),
      });
      if (res?.status !== 200) {
        toast.warning(res?.message);
      }
      return res?.docs;
    },
  });

  return (
    <div className="w-full px-6 py-8 bg-white rounded-lg">
      <div className="mb-8 border-b border-gray-200 flex items-center justify-between">
        <div className="flex flex-col gap-2 w-full">
          <h1 className="font-bold text-lg xl:text-2xl tracking-tighter uppercase text-slate-900 font-Montserrat">
            {t("Organization Settings")}
          </h1>
          <div className="text-sm xl:text-base">
            {t(organization[0]?.description)}
          </div>
        </div>
        {/* <Button buttonLabel={"Create Organization"} variant="secondary" /> */}
      </div>

      <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 xl:grid-cols-5">
        {organizerData?.data?.map((item, index) => (
          <OrganizationItem
            selectedOrganization={selectedOrganization}
            item={item}
            key={index}
          />
        ))}
      </div>
    </div>
  );
}
